/**
 * @description The type of the processor responsible for eKYC of the customer.
 */
export enum CustomerIdentificationProcessorType {
  ManualCustomerService = 'ManualCustomerService',
  Sofort = 'Sofort', // technically, this belongs in payment processors, but it is sometimes used for kyc, too.
  ExperianPreciseId = 'ExperianPreciseId', //PID
  ExperianKnowledgeId = 'ExperianKnowledgeId', //KIQ
  IdologyQuestions = 'IdologyQuestions', //ExpectID IQ - for questions and answers
  IdologyAutoProfile = 'IdologyAutoProfile', //ExpectID - for flat response, no follow up questions
  TruNarrative = 'TruNarrative',
  CustomerServiceMatchedExistingCustomer = 'CustomerServiceMatchedExistingCustomer', //match through CS
  OnlineMatchedExistingCustomer = 'OnlineMatchedExistingCustomer', //match through website
  JumioKyc = 'JumioKyc',
  IOvationDeviceVerification = 'IOvationDeviceVerification',
  Veda = 'Veda',
  Id3Global = 'Id3Global', //UK KYC Provider
  Onfido = 'Onfido',
  Veriff = 'Veriff',
  Signicat = 'Signicat',
  Microblink = 'Microblink'
}



// WEBPACK FOOTER //
// ./src/model/types/customer-identification-processor-type.ts